import BaseGroup, { GroupProps as BaseGroupProps } from 'antd/lib/input/Group'

export interface InputGroupProps extends BaseGroupProps {}

export const InputGroup = (props: InputGroupProps): JSX.Element => (
  <>
    <BaseGroup {...props} />
  </>
)
